import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Navbar from "../../pages/Navbar";

import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  CircularProgress,
  IconButton,
  TablePagination,
} from "@mui/material";

import { Search, IosShare } from "@mui/icons-material";

const ManagerReport = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    console.log("Manager Report Mounted");
    fetchReport();
  }, []);

  const fetchReport = async () => {
    try {
      const { API_CONFIG } = require("../../configuration");

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${API_CONFIG.APIURL}/report/Manager-Report`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setData(response.data.data || []);
      setFilteredData(response.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);

    const filtered = data.filter((row) =>
      Object.values(row).join(" ").toLowerCase().includes(value),
    );

    setFilteredData(filtered);
    setPage(0);
  };

  const exportToExcel = () => {
    const exportData = filteredData.map((item) => ({
      Asset_ID: item.asset_id,
      Asset_Type: item.brand,
      Model: item.model,
      IMEI_Number: item.imei_num,
      Asset_Purchased_From: item.asset_purchased_from,
      Po_NUM: item.po_num,
      PO_DATE: item.po_date,
      //   3 colms missing
      Description: item.description,
      Asset_Status: item.assignment_status || "Free Pool",
      Location: item.base_location,
      State: item.state,
      Accepted_by:item.accepted_by,
      Accepted_date: item.accepted_date,
      Acceptance_status:item.acceptance_status,
      Requested_by: item.requested_by,
      Approved_by: item.approved_by,
      Assigned_to: item.assigned_to,
      Employee_ID: item.emp_id,
      Employee_Name: item.emp_name,
      Employee_Email: item.emp_email,
      Employee_Mobile: item.emp_mob,
      Department: item.department_name,
      Designation: item.designation_name,
      reporting_manager: item.reporting_manager,
      Host_Name: item.host_name,
      Warranty_Status: item.warranty_status,
      warranty_support: item.warranty_support,
      Assigned_Date: item.assigned_date,
      Branch: item.branchid_name,
      Area: item.areaid_name,
      Region: item.regionid_name,
      Cluster: item.clusterid_name,
      Remarks: item.remarks,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Manager Report");

    XLSX.writeFile(workbook, `Manager_Report_${new Date().getTime()}.xlsx`);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Navbar />

      <Box
        sx={{
          p: { xs: 2, md: 4 },
          ml: { xs: 0, md: "250px" },
          width: {
            xs: "100%",
            md: "calc(100% - 250px)",
          },
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography variant="h5" fontWeight="bold" color="primary">
            Assets Master Report
          </Typography>

          <Box display="flex" gap={2}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ddd",
                borderRadius: "25px",
                px: 2,
                width: 300,
              }}
            >
              <Search />
              <TextField
                variant="standard"
                fullWidth
                placeholder="Search..."
                InputProps={{
                  disableUnderline: true,
                }}
                value={search}
                onChange={handleSearch}
              />
            </Box>

            <IconButton color="primary" onClick={exportToExcel}>
              <IosShare />
            </IconButton>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            height: "65vh",
            overflow: "auto",
            borderRadius: 3,
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Asset ID
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Brand
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Model
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  IMEI
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Accepted By
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Accepted Date
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Status
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Emp ID
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Employee Name
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Department
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Designation
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Branch
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    backgroundColor: "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.asset_id}</TableCell>
                    <TableCell>{row.brand}</TableCell>
                    <TableCell>{row.model}</TableCell>
                    <TableCell>{row.imei_num}</TableCell>
                    <TableCell>{row.accepted_by}</TableCell>
                    <TableCell>{row.accepted_date}</TableCell>
                    <TableCell>{row.acceptance_status}</TableCell>
                    <TableCell>{row.emp_id}</TableCell>
                    <TableCell>{row.emp_name}</TableCell>
                    <TableCell>{row.department_name}</TableCell>
                    <TableCell>{row.designation_name}</TableCell>
                    <TableCell>{row.branchid_name}</TableCell>
                    <TableCell>
                      {row.assignment_status || "Free Pool"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Box>
    </>
  );
};

export default ManagerReport;
